<template>
  <Widget class="red-flags-widget">
    <v-card style="border-radius: 6px" flat>
      <v-card-title
        class="title text-left d-flex mb-4"
        :style="{ backgroundColor: 'var(--red)' }"
      >
        <AppkitIcon class="pt-1 mr-2" icon="icon-flag-outline" size="large">
        </AppkitIcon
        >Red Flags</v-card-title
      >
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <v-progress-circular
            class="mt-6"
            :width="6"
            :size="140"
            color="var(--red)"
            model-value="100"
          >
            <div class="appkit-data red-flag-counter">
              {{ statsStore.flagging.suppliersWithDisclosedBreaches }}
            </div>
          </v-progress-circular>
        </v-col>
      </v-row>
      <v-row justify="center" class="mb-2">
        <v-col cols="10">
          <v-card-text>
            <p>Total number of units with disclosed breaches in supply chain</p>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </Widget>
</template>

<script setup lang="ts">
import Widget from "@/views/dashboard-view/Widget.vue";
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import { useStatsStore } from "@/stores/statsStore";

const statsStore = useStatsStore();
</script>

<style scoped lang="scss">
.title {
  color: white;
}
.red-flags-widget {
  p {
    color: var(--dark-grey);
    font-size: 15px;
  }
}
.red-flag-counter {
  color: black;
}
</style>
